import { getTreatments } from '../lib/experiment-utils'

const useTreatment = ({ name }: { name: string }) => {
  const treatments = getTreatments([name])

  return !!treatments[name]
}

export default useTreatment
